export const AppRoutes = {
    AUTH: {
        LOGIN: "/auth/login",
        LOGOUT: "/auth/logout",
        USER: "/auth/user",
        REFRESH: "/auth/refresh",
    },
    DASHBOARD: {
        INDEX: "/dashboard",
    },
    PROFILE: {
        INDEX: "/account-profile",
    },
    USER: {
        ADD_EDIT: "/administration/user/add-edit",
        LIST: "/administration/user/list",
        FORCE_CHANGE_PASSWORD: "/force-change-password",
        // Profile: '/user/profile',
    },
    CONFIGURATION: {
        INDEX: "/configuration",

        CATEGORIES: {
            LIST: "/configuration/categories/list",
            ADD_EDIT: "/configuration/categories/add-edit",
        },

        LIBRARIES: {
            LIST: "/configuration/libraries/list",
            ADD_EDIT: "/configuration/libraries/add-edit",
        },

        FEATURES: {
            LIST: "/configuration/features/list",
            ADD_EDIT: "/configuration/features/add-edit",
        },

        FEATURE_GROUPS: {
            LIST: "/configuration/feature-groups/list",
            ADD_EDIT: "/configuration/feature-groups/add-edit",
        },

        DEVICE_THRESHOLD: {
            LIST: "/configuration/device-threshold/list",
            ADD_EDIT: "/configuration/device-threshold/add-edit",
        },

        THRESHOLD_GROUPS: {
            LIST: "/configuration/threshold-groups/list",
            ADD_EDIT: "/configuration/threshold-groups/add-edit",
        },

        RELAY_PROFILES: {
            LIST: "/configuration/relay-profiles/list",
            ADD_EDIT: "/configuration/relay-profiles/add-edit",
        },
        RELAYS: {
            INDEX: "/configuration/relays",
            LIST: "/configuration/relays/list",
            ADD_EDIT: "/configuration/relays/add-edit",
        },
        DEVICE_TYPES: {
            LIST: "/configuration/device-types/list",
            ADD_EDIT: "/configuration/device-types/add-edit",
        },
        DASHBOARD_TEMPLATE: {
            LIST: "/configuration/dashboard-template/list",
            ADD_EDIT: "/configuration/dashboard-template/add-edit",
        },
    },
    CATALOG: {
        INDEX: "/catalog",

        MANUFACTURERS: {
            LIST: "/catalog/manufacturers/list",
            ADD_EDIT: "/catalog/manufacturers/add-edit",
        },

        DEVICE_MODELS: {
            LIST: "/catalog/models/list",
            ADD_EDIT: "/catalog/models/add-edit",
        },

        HARDWARE_VERSIONS: {
            LIST: "/catalog/hardware-versions/list",
            ADD_EDIT: "/catalog/hardware-versions/add-edit",
        },

        FIRMWARE_VERSIONS: {
            LIST: "/catalog/firmware-versions/list",
            ADD_EDIT: "/catalog/firmware-versions/add-edit",
        },

        DEVICE_TAGS: {
            LIST: "/catalog/tags/list",
            ADD_EDIT: "/catalog/tags/add-edit",
        },

        CATEGORIES: {
            LIST: "/catalog/units/list",
            ADD_EDIT: "/catalog/units/add-edit",
        },

        PROTOCOLS: {
            LIST: "/catalog/protocols/list",
            ADD_EDIT: "/catalog/protocols/add-edit",
        },
        UNITS: {
            LIST: "/catalog/units/list",
            ADD_EDIT: "/catalog/units/add-edit",
        },
        DATA_FORMATS: {
            LIST: "/catalog/data-formats/list",
            ADD_EDIT: "/catalog/data-formats/add-edit",
        },
        DATA_TYPES: {
            LIST: "/catalog/data-types/list",
            ADD_EDIT: "/catalog/data-types/add-edit",
        },
    },
    METADATA: {
        INDEX: "/metadata",

        FIELD_DICTIONARY: {
            LIST: "/metadata/field-dictionary/list",
            ADD_EDIT: "/metadata/field-dictionary/add-edit",
        },

        FIELD_GROUPS: {
            LIST: "/metadata/field-groups/list",
            ADD_EDIT: "/metadata/field-groups/add-edit",
        },
    },
    ADMINISTRATION: {
        INDEX: "/administration",

        USERS: {
            LIST: "/administration/users/list",
            ADD_EDIT: "/administration/users/add-edit",
            FORCE_CHANGE_PASSWORD: "/profile/force-change-password",
            UPDATE_PROFILE: "/profile/update-profile",
        },

        ROLES: {
            LIST: "/administration/roles/list",
            ADD_EDIT: "/administration/roles/add-edit",
        },

        // PERMISSIONS: {
        //     LIST: "/administration/permissions/list",
        //     ADD_EDIT: "/administration/permissions/add-edit",
        // },

        ORGANIZATIONS: {
            LIST: "/administration/organizations/list",
            ADD_EDIT: "/administration/organizations/add-edit",
        },
    },
    LOGS: {
        INDEX: "/logs",

        ACTIVITY: {
            LIST: "/logs/activity-logs/list",
        },

        AUDIT: {
            LIST: "/logs/audit-logs/list",
        },

        AUTHENTICATION: {
            LIST: "/logs/authentication-logs/list",
        },

        SESSION: {
            LIST: "/logs/session-logs/list",
        },

        DEVICE: {
            LIST: "/logs/device-logs/list",
        },

        GATEWAY: {
            LIST: "/logs/gateway-logs/list",
        },

        MQTT: {
            LIST: "/logs/mqtt-logs/list",
        },

        API: {
            LIST: "/logs/api-logs/list",
        },

        SYSTEM: {
            LIST: "/logs/system-logs/list",
        },

        SYSLOG: {
            LIST: "/logs/syslog/list",
        },
        ACCESS: {
            LIST: "/logs/access-logs/list",
        },

        ADMINISTRATIVE: {
            LIST: "/logs/administrative-logs/list",
        },
    },
    ESL: {

        DASHBOARD: {
            INDEX: "/esl-management/dashboard",
        },
        CONTENT: {
            LIST: "/esl-management/content/list",
            ADD_EDIT: "/esl-management/content/add-edit",
        },

        STORE_FIELD: {
            LIST: "/esl-management/store-fields/list",
            ADD_EDIT: "/esl-management/store-fields/add-edit",
        },

        STORE_TEMPLATE: {
            LIST: "/esl-management/store-template/list",
            ADD_EDIT: "/esl-management/store-template/add-edit",
        },

        GATEWAY: {
            LIST: "/esl-management/gateway/list",
            ADD_EDIT: "/esl-management/gateway/add-edit",
        },

        DEVICE: {
            LIST: "/esl-management/device/list",
            ADD_EDIT: "/esl-management/device/add-edit",
        },
    },
    SERVICES: {
        INDEX: "/services",

        EMAIL: {
            LIST: "/services/email/list",
            ADD_EDIT: "/services/email/add-edit",
        },

        TELEGRAM: {
            LIST: "/services/telegram/list",
            ADD_EDIT: "/services/telegram/add-edit",
        },

        SMS: {
            LIST: "/services/sms/list",
            ADD_EDIT: "/services/sms/add-edit",
        },

        PUSH_NOTIFICATION: {
            LIST: "/services/push-notification/list",
            ADD_EDIT: "/services/push-notification/add-edit",
        },

        WHATSAPP: {
            LIST: "/services/whatsapp/list",
            ADD_EDIT: "/services/whatsapp/add-edit",
        },

        WEBHOOK: {
            LIST: "/services/webhook/list",
            ADD_EDIT: "/services/webhook/add-edit",
        },
    },
    SYSTEM: {
        INDEX: "/system",

        DATE_TIME: {
            ADD_EDIT: "/system/date-time",
        },

        MAINTENANCE: {
            INDEX: "/system/maintenance",
        },
        BACKUP_RESTORE: {
            LIST: "/system/backup-restore/list",
            ADD_EDIT: "/system/backup-restore/add-edit",
        },

        CLUSTER: {
            INDEX: "/system/cluster/settings",
        },

        LICENSE: {
            LIST: "/system/license/list",
        },
        MONITORING: {
            INDEX: "/system/monitoring",
        },
    },
    SETTINGS: {
        INDEX: "/settings",

        SYSTEM_CONFIGURATION: {
            INDEX: "/settings/sys-config",
        },
    },
    GATEWAYS: {
        INDEX: "/gateways",

        ONBOARDING: {
            LIST: "/gateways/onboarding/list",
            ADD_EDIT: "/gateways/onboarding/add-edit",
        },

        INVENTORY: {
            LIST: "/gateways/inventory-manager/list",
            ADD_EDIT: "/gateways/inventory-manager/add-edit",
        },

        PROFILES: {
            LIST: "/gateways/gateway-profiles/list",
            ADD_EDIT: "/gateways/gateway-profiles/add-edit",
        },
    },
    DEVICES: {
        INDEX: "/devices",

        ONBOARDING: {
            LIST: "/devices/onboarding/list",
            ADD_EDIT: "/devices/onboarding/add-edit",
        },

        INVENTORY: {
            LIST: "/devices/inventory-manager/list",
            ADD_EDIT: "/devices/inventory-manager/add-edit",
        },

        PROFILES: {
            LIST: "/devices/device-profiles/list",
            ADD_EDIT: "/devices/device-profiles/add-edit",
        },
    },
    ALERTS: {
        INDEX: "/alerts",

        ACTIVE: {
            LIST: "/alerts/active/list",
        },

        RULES: {
            LIST: "/alerts/rules/list",
            ADD_EDIT: "/alerts/rules/add-edit",
        },

        PROFILES: {
            LIST: "/alerts/profiles/list",
            ADD_EDIT: "/alerts/profiles/add-edit",
        },

        NOTIFICATIONS: {
            LIST: "/alerts/notifications/list",
            ADD_EDIT: "/alerts/notifications/add-edit",
        },

        ESCALATION: {
            LIST: "/alerts/escalation/list",
            ADD_EDIT: "/alerts/escalation/add-edit",
        },

        HISTORY: {
            LIST: "/alerts/history/list",
        },

        MAINTENANCE_WINDOW: {
            LIST: "/alerts/maintenance-window/list",
            ADD_EDIT: "/alerts/maintenance-window/add-edit",
        },
    },
    MONITORING: {
        INDEX: "/monitoring",

        DASHBOARD: {
            INDEX: "/monitoring/dashboard",
        },
        LIVE_DEVICES: {
            LIST: "/monitoring/live-devices/list",
        },

        GATEWAY_HEALTH: {
            LIST: "/monitoring/gateway-health/list",
        },

        DEVICE_HEALTH: {
            LIST: "/monitoring/device-health/list",
        },
    },
    TRACKING: {
        INDEX: "/tracking",

        ASSETS: {
            LIST: "/tracking/assets/list",
        },

        DEVICES: {
            LIST: "/tracking/devices/list",
        },

        GATEWAYS: {
            LIST: "/tracking/gateways/list",
        },

        LOCATION_HISTORY: {
            LIST: "/tracking/location-history/list",
        },

        GEOFENCING: {
            LIST: "/tracking/geofencing/list",
        },
    },
    EVENTS: {
        INDEX: "/events",
        LIVE: {
            LIST: "/events/live/list",
        },

        HISTORY: {
            LIST: "/events/history/list",
        },

        RULES: {
            LIST: "/events/rules/list",
            ADD_EDIT: "/events/rules/add-edit",
        },

        CATEGORIES: {
            LIST: "/events/categories/list",
            ADD_EDIT: "/events/categories/add-edit",
        },

        CORRELATION: {
            LIST: "/events/correlation/list",
            ADD_EDIT: "/events/correlation/add-edit",
        },
    },
    // INFRASTRUCTURE
    FACILITIES: {
        SITES: {
            INDEX: "/sites",
            DASHBOARD: "/sites/dashboard",
            LIST: "/sites/list",
            ADD_EDIT: "/sites/add-edit",
        },

        LOCATION: {
            LIST: "/sites/location/list",
            ADD_EDIT: "/sites/location/add-edit",
        },

        AREA: {
            LIST: "/sites/area/list",
            ADD_EDIT: "/sites/area/add-edit",
            MAP: "/sites/area/area-map",
        },
    },
    RULES: {
        LIST: "/rules/list",
        ADD_EDIT: "/rules/add-edit",
    },
    //   SENSOR_DASHBOARD: {
    //     PATH: "/sensor-dashboard/:sensorType/:deviceId",

    //     getPath: (sensorType, deviceId) =>
    //       `/sensor-dashboard/${sensorType}/${deviceId}`,
    //   },
    SENSOR_DASHBOARD: {
        PATH: "/sensor-dashboard/:sensorType",
        getPath: (sensorType) => `/sensor-dashboard/${sensorType}`,
    },

    RFID: {
        DASHBOARD: {
            INDEX: "/rfid/dashboard",
        },
        CARDS: {
            LIST: "/rfid/cards/list",
            ADD_EDIT: "/rfid/cards/add-edit",
        },
        EDGE_DEVICES: {
            LIST: "/rfid/edge-devices/list",
            DETAILS: "/rfid/edge-devices/details",
            ADD_EDIT: "/rfid/edge-devices/add-edit",
        },
        READERS: {
            LIST: "/rfid/readers/list",
            ADD_EDIT: "/rfid/readers/add-edit",
        },
        SCHEDULES: {
            LIST: "/rfid/schedules/list",
            ADD_EDIT: "/rfid/schedules/add-edit",
        },
        ACCESS_POLICIES: {
            LIST: "/rfid/access-policies/list",
            ADD_EDIT: "/rfid/access-policies/add-edit",
        },
        EDGE_COMMANDS: {
            LIST: "/rfid/edge-commands/list",
            ADD_EDIT: "/rfid/edge-commands/add-edit",
        },
        ACCESS_LOGS: {
            LIST: "/rfid/access-logs/list",
        },
        HEALTH_HISTORY: {
            LIST: "/rfid/health-history/list",
        },
        STATUS_HISTORY: {
            LIST: "/rfid/status-history/list",
        },
        SYNC_HISTORY: {
            LIST: "/rfid/sync-history/list",
        },
    },
};
